import { Row } from 'antd'
import LoginForm from 'src/components/loginForm/LoginForm'

export const SignIn = () => {
  return (
    <Row justify='center' align='center' style={{ width: '100%' }}>
      <LoginForm />
    </Row>
  )
}
